module.exports = __webpack_public_path__ + "img/motor_no21.0eb0d054.jpg";